interface IconProps {
  className?: string;
  color?: string;
}

/**
 * Icône Building (Coopératives & Chambres)
 */
export function BuildingIcon({ className = "w-8 h-8", color = "#2563EB" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Bâtiment principal */}
      <rect x="20" y="25" width="60" height="65" rx="3" fill={color}/>
      {/* Fenêtres */}
      <rect x="30" y="35" width="8" height="8" rx="1" fill="white" opacity="0.8"/>
      <rect x="46" y="35" width="8" height="8" rx="1" fill="white" opacity="0.8"/>
      <rect x="62" y="35" width="8" height="8" rx="1" fill="white" opacity="0.8"/>
      <rect x="30" y="50" width="8" height="8" rx="1" fill="white" opacity="0.8"/>
      <rect x="46" y="50" width="8" height="8" rx="1" fill="white" opacity="0.8"/>
      <rect x="62" y="50" width="8" height="8" rx="1" fill="white" opacity="0.8"/>
      <rect x="30" y="65" width="8" height="8" rx="1" fill="white" opacity="0.8"/>
      <rect x="46" y="65" width="8" height="8" rx="1" fill="white" opacity="0.8"/>
      <rect x="62" y="65" width="8" height="8" rx="1" fill="white" opacity="0.8"/>
      {/* Porte */}
      <rect x="42" y="78" width="16" height="12" rx="1" fill="white" opacity="0.9"/>
      {/* Toit */}
      <path d="M15 25 L50 10 L85 25" stroke={color} strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

/**
 * Icône Recherche (Instituts & Chercheurs)
 */
export function ResearchIcon({ className = "w-8 h-8", color = "#2563EB" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Microscope base */}
      <rect x="30" y="80" width="40" height="8" rx="2" fill={color}/>
      {/* Corps */}
      <path d="M50 75 L50 45" stroke={color} strokeWidth="6" strokeLinecap="round"/>
      {/* Oculaire */}
      <circle cx="50" cy="35" r="8" fill={color}/>
      {/* Bras incliné */}
      <path d="M50 55 L70 35" stroke={color} strokeWidth="5" strokeLinecap="round"/>
      {/* Objectif */}
      <circle cx="72" cy="32" r="6" fill={color} opacity="0.7"/>
      {/* Lame */}
      <rect x="45" y="60" width="20" height="3" rx="1" fill={color} opacity="0.6"/>
      {/* Éléments décoratifs */}
      <circle cx="35" cy="25" r="4" stroke={color} strokeWidth="2" fill="none" opacity="0.5"/>
      <circle cx="28" cy="35" r="3" stroke={color} strokeWidth="2" fill="none" opacity="0.5"/>
      <path d="M60 22 L65 17 M62 20 L65 20 M62 20 L62 17" stroke={color} strokeWidth="2" strokeLinecap="round" opacity="0.5"/>
    </svg>
  );
}

/**
 * Icône Vignoble (Domaines viticoles)
 */
export function VineyardIcon({ className = "w-8 h-8", color = "#2563EB" }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Rangées de vignes */}
      {/* Rangée 1 */}
      <path d="M20 40 Q25 35 30 40 T40 40" stroke={color} strokeWidth="3" fill="none" opacity="0.7"/>
      <circle cx="25" cy="38" r="3" fill={color} opacity="0.8"/>
      <circle cx="35" cy="38" r="3" fill={color} opacity="0.8"/>
      {/* Rangée 2 */}
      <path d="M45 50 Q50 45 55 50 T65 50" stroke={color} strokeWidth="3" fill="none"/>
      <circle cx="50" cy="48" r="4" fill={color}/>
      <circle cx="60" cy="48" r="4" fill={color}/>
      {/* Rangée 3 */}
      <path d="M25 60 Q30 55 35 60 T45 60" stroke={color} strokeWidth="3" fill="none" opacity="0.7"/>
      <circle cx="30" cy="58" r="3" fill={color} opacity="0.8"/>
      <circle cx="40" cy="58" r="3" fill={color} opacity="0.8"/>
      {/* Piquets */}
      <line x1="25" y1="42" x2="25" y2="70" stroke={color} strokeWidth="2" opacity="0.5"/>
      <line x1="35" y1="42" x2="35" y2="70" stroke={color} strokeWidth="2" opacity="0.5"/>
      <line x1="50" y1="52" x2="50" y2="70" stroke={color} strokeWidth="2" opacity="0.6"/>
      <line x1="60" y1="52" x2="60" y2="70" stroke={color} strokeWidth="2" opacity="0.6"/>
      {/* Grappe de raisin (icon principal) */}
      <circle cx="75" cy="28" r="5" fill={color}/>
      <circle cx="70" cy="35" r="5" fill={color}/>
      <circle cx="80" cy="35" r="5" fill={color}/>
      <circle cx="75" cy="42" r="5" fill={color}/>
      {/* Feuille */}
      <path d="M75 20 Q70 15 75 10 Q80 15 75 20" fill={color} opacity="0.7"/>
      {/* Sol */}
      <line x1="15" y1="75" x2="85" y2="75" stroke={color} strokeWidth="4" strokeLinecap="round" opacity="0.4"/>
    </svg>
  );
}
